<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.ColorSelect({
              label: 'Kolor (domyślnie Podstawowy)',
              modelPath: [this, 'form', 'color']
            }),
            new fields.Input({
              label: 'Title',
              modelPath: [this, 'form', 'title'],
              multilingual: true
            }),
            new fields.Input({
              label: 'Kod',
              modelPath: [this, 'form', 'content'],
              type: 'textarea',
              required: true
            })
          ]
        }
      ]
    }
  }
}
</script>
